import {NgModule, Component, OnInit} from '@angular/core';
import {BrowserModule}   from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";

import {PanelModule,DataTableModule} from 'primeng/primeng';
import {SplitButtonModule,MenuModule,MenuItem,SelectItem, DropdownModule} from 'primeng/primeng';
import {TreeModule,ContextMenuModule} from 'primeng/primeng';



import{ExDialogExModule}from '../../component/dialog_ex.component'
import{GuideService} from '../../service/guide_service.component';
import{ErrorService,UriError,TypeError} from '../../error/error';

import{ThirdPartyCompany} from '../../model/thirdpartycompany';
import{AttributeType} from '../../model/attribute_type';
import{AttributeValue} from '../../model/attribute_value';
import {UserGroup} from '../../model/usergroup';

import {URLSearchParams, Headers, HttpModule} from '@angular/http';
import {CommonModule} from "@angular/common";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {CookieService} from "angular2-cookie/services/cookies.service";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service";
import * as glob from "../../service/global_url";



enum DLG_Type {
	DLG_ADD,DLG_REMOVE,DLG_UPDATE
}

@Component({
    selector:'page',
    templateUrl:'./company_mgr.page.html',
    styleUrls : ['./company_mgr.page.css']

})
export class CompanyManagerPageComponent implements OnInit{

    private url_company:string  = "/mgr/system/company";
    private url_atttype:string  = "/mgr/system/attribute/type";
    private url_atvalue:string  = "/mgr/system/attribute/value";

    private company_menu_item: MenuItem[];
    private company_list:ThirdPartyCompany[];
    private company_select_item:ThirdPartyCompany = Object.assign({});
    private company_edit_item:ThirdPartyCompany = Object.assign({});
    private company_list_pageable:boolean = true;

    private dlg_com_show:boolean = false;
    private dlg_com_disable:boolean = false;
    private dlg_com_header:string;
    private dlg_com_type:DLG_Type;
		private dlg_com_id_hide : boolean = false;
		private dlg_com_type_disable : boolean = true;

    /////////////////////////////////////////////////////////////
    private attribute_list:AttributeType[] = [];
    private attribute_menu_item: MenuItem[];
    private attribute_select_item:AttributeType= Object.assign({});
    private attribute_edit_item:AttributeType= Object.assign({});

    private dlg_att_show:boolean = false;
    private dlg_att_disable:boolean = false;
    private dlg_att_header:string;
    private dlg_att_type:DLG_Type;

    /////////////////////////////////////////////////////////////
    private attrvalue_root_node:UserGroup[];
    private attrvalue_selected_node:UserGroup;
    private attrvalue_context_menu_item: MenuItem[];
    private attrvalue_edit_item:AttributeValue =Object.assign({});

    private dlg_atv_show:boolean;
    private dlg_atv_disable:boolean;
    private dlg_atv_header:string;
    private dlg_atv_type:DLG_Type;

    private kyungnamIsTrue:boolean = glob.kyungnamIsTrue;

		companyType_item : SelectItem[];

    translate : TranslateServiceForm;

    addValueForm : any;
    /////////////////////////////////////////////////////////////////////////
    constructor(private service:GuideService, private error:ErrorService, private logger : Logger, private cookie : CookieService, private _translate : TranslateServiceForm){
       this.loadCompanyList();
       this.translate = _translate;

    }
    ngOnInit() {
			if(this.cookie.get('roleType') != 'ROLE_SUPER_MANAGER') {
				this.company_menu_item = [
						{label: 'UPDATE', icon: 'fa-pencil-square-o', command:() => {this.openCompanyDlg(DLG_Type.DLG_UPDATE)}}
				];
			}
			else {
				this.company_menu_item = [
						{label: 'ADD', icon: 'fa-plus', command:()  => { this.openCompanyDlg(DLG_Type.DLG_ADD)}},
						{label: 'REMOVE', icon: 'fa-times', command:() => { this.openCompanyDlg(DLG_Type.DLG_REMOVE)}},
						{label: 'UPDATE', icon: 'fa-pencil-square-o', command:() => {this.openCompanyDlg(DLG_Type.DLG_UPDATE)}}
				];
			}

        this.attribute_menu_item = [
            {label: 'ADD', icon: 'fa-plus', command:()  => { this.openAttributeDlg(DLG_Type.DLG_ADD)}},
            {label: 'REMOVE', icon: 'fa-times', command:() => { this.openAttributeDlg(DLG_Type.DLG_REMOVE)}},
            {label: 'UPDATE', icon: 'fa-pencil-square-o', command:() => {this.openAttributeDlg(DLG_Type.DLG_UPDATE)}}
        ];
        this.attrvalue_context_menu_item =[
            {label: 'ADD', icon: 'fa-plus', command:()      => { this.openAttributeValueDlg(DLG_Type.DLG_ADD)}},
            {label: 'REMOVE', icon: 'fa-times', command:()  => { this.openAttributeValueDlg(DLG_Type.DLG_REMOVE)}},
            //20200515 박두호 애트리뷰트 수정버튼
            {label: 'UPDATE', icon: 'fa-pencil-square-o', command:()      => { this.openAttributeValueDlg(DLG_Type.DLG_UPDATE)}}
        ];

			this.companyType_item = [];
			this.companyType_item.push({label: 'admin', value: "TYPE_TO_NORMAL"});
		    this.companyType_item.push({label: 'visitor', value: "TYPE_TO_VISITOR"});
    }
    
    private loadCompanyList():void{
        this.service.get(this.url_company,null,null).subscribe(
            value => {
                try{
                    if(!(value.content instanceof Array) ){
                        throw new TypeError("loadCompanyList()",value,this.url_company);
                    }
                    this.company_list = value.content;
                }catch(e){
                    this.error.handle(e);
                }
            },err=>{this.error.handle(new UriError("loadCompanyList()",err,this.url_company));}
        )
    }
    private addCompany():void{
        var p_params = new URLSearchParams();
        if(this.company_edit_item.name == ""){
            alert(this.translate.instant('MESSAGE_Enter_Company_Name'));
        }else{
            p_params.set("name",this.company_edit_item.name);
            p_params.set("companyType", String(this.company_edit_item.companyType));
            this.service.post(this.url_company,null,p_params).subscribe(
                value => {
                    this.company_list.push(value);
                    this.logger.debug("-- value : " , value);
                    if(value.id ==0){
                        alert(this.translate.instant('MESSAGE_Duplicate_Company'));
                    }else{
                        alert(this.translate.instant('MESSAGE_Added_Complete'));
                    }
                }, error=>{this.logger.error("-- error : " + error);}
            )
        }
    }
    private removeCompany():void{
        var url_path = "/mgr/system/company";
        this.service.del(this.url_company,String(this.company_edit_item.id),null).subscribe(
            value => {
                this.logger.debug("-- value : " , value);
                this.loadCompanyList();
            },error=>{this.logger.error("-- error : " + error);}
        )
    }
    private updateCompany():void{
        this.logger.debug("company_edit_item", this.company_edit_item);
        if(this.company_edit_item.name == ''){
            alert(this.translate.instant('MESSAGE_Enter_Company_Name'));
        }else{
            this.service.put(this.url_company,null,this.company_edit_item).subscribe(
                value => {
                    this.logger.debug("-- value : " , value);
                    this.loadCompanyList();
                }, error=>{this.logger.error("-- error : " + error);}
            )
        }
    }
    private onDlgOk_Company(event:any){
        this.logger.debug("COMPANY DLG RESULT : OK " , event);
        switch(this.dlg_com_type){
             case DLG_Type.DLG_ADD:
                this.addCompany();
            break;
            case DLG_Type.DLG_REMOVE:
                this.removeCompany();
            break;
            case DLG_Type.DLG_UPDATE:
                this.updateCompany();
            break;
        }
    }
    private openCompanyDlg(type:DLG_Type):void{
        this.dlg_com_show = true;
        this.dlg_com_type = type;

        this.company_edit_item = Object.assign({},this.company_select_item);
        switch(type){
            case DLG_Type.DLG_ADD:
                this.dlg_com_header  = "COMPANY - ADD ";
                this.dlg_com_disable = false;
								this.dlg_com_id_hide = true;
								this.dlg_com_type_disable = false;
								this.company_edit_item.name = '';
								this.company_edit_item.companyType = this.companyType_item[0].value;

            break;
            case DLG_Type.DLG_REMOVE:
                this.dlg_com_header  = "COMPANY - REMOVE ";
                this.dlg_com_disable = true;
								this.dlg_com_id_hide = false;
            break;
            case DLG_Type.DLG_UPDATE:
                this.dlg_com_header  = "COMPANY - UPDATE ";
                this.dlg_com_disable = false;
								this.dlg_com_id_hide = false;
								this.dlg_com_type_disable = true
            break;
        }
    }
    private onComapnySelected(event:any){
        this.company_select_item = event.data;
        this.company_edit_item = Object.assign({},this.company_select_item);
        this.logger.debug("company : " , this.company_select_item);

        this.loadAttributeList(this.company_select_item.id);
    }


////////////////////////////////////////////////////////////////////////////////////////////////////


    private loadAttributeList(companyId:number):void{
        var url = this.url_atttype + "/all";
        var p_params = new URLSearchParams();
        p_params.set("companyId" ,String(this.company_select_item.id));
        this.service.get(url,null,p_params).subscribe(
            value => {
                this.attribute_list = value;
                this.attrvalue_root_node = [];
								this.logger.debug("this.attribute_list :", this.attribute_list);

								if(this.attribute_list.length <= 0) {
									this.attribute_select_item = Object.assign({});
								}


            },error=>{this.logger.error("-- error : " + error);}
        )
    }

    private addAttributeType():void{
        
        var p_params = new URLSearchParams();
        this.logger.debug("company_select_item",this.company_select_item);

        p_params.set("companyId" ,String(this.company_select_item.id));
        p_params.set("idx" ,String(this.attribute_list.length));
        p_params.set("code",this.attribute_edit_item.code);
        p_params.set("name",this.attribute_edit_item.name);
        p_params.set("dsc" ,this.attribute_edit_item.dsc);
        this.logger.debug("p_params", p_params);
        /*if(this.attribute_edit_item.code == ''){
            alert("속성 타입 code를 입력해주세요.");
        }*/
        if(this.attribute_edit_item.name == ''){
            alert(this.translate.instant('MESSAGE_Enter_AttributeType_Name'));
        }else{
            this.service.post(this.url_atttype,null,p_params).subscribe(
                value => {
                    this.logger.debug("-- value : " , value);
                    var attributeType:AttributeType = value;
                    if(value.id == -1){
                        //alert("코드 또는 이름이 이미 존재 합니다.");
                        alert(this.translate.instant('MESSAGE_Name_Exist'));
                    }else{
                        this.attribute_list.push(attributeType);
                    }
                },error=>{this.logger.error("-- error : " + error);}
            )
        }


    }
    private removeAttributeType():void{
        this.service.del(this.url_atttype,String(this.attribute_edit_item.id),null).subscribe(
            value => {
								this.logger.debug("remove Attribute")
                this.loadAttributeList(this.company_select_item.id);
						},error=>{this.logger.error("-- error : " + error);}
        )
    }
    private updateAttributeType():void{
        //this.logger.debug("수정할 데이터들",this.attribute_edit_item);
        let updateItem = {id : this.attribute_edit_item.id, idx: this.attribute_edit_item.idx, code: this.attribute_edit_item.code, dsc : this.attribute_edit_item.dsc , type: this.attribute_edit_item.type, depth: this.attribute_edit_item.depth, name: this.attribute_edit_item.name};
        //id , idx, code, dsc, type , depth, parent,
        /*if(this.attribute_edit_item.code == ''){
            alert("속성 타입 code를 입력해주세요.");
        }*/
        if(this.attribute_edit_item.name == ''){
            alert(this.translate.instant('MESSAGE_Enter_AttributeType_Name'));
        }else {
            this.service.put(this.url_atttype, null, updateItem).subscribe(
                value => {
                    this.logger.debug("-- value : ", value);
                    if (value.id == -1) {
                        alert(this.translate.instant('MESSAGE_Name_Exist'));
                    } else {
                        this.loadAttributeList(this.company_select_item.id);
                    }
                }, error => {
                    this.logger.error("-- error : " + error);
                },
                () => {
                }
            )
        }
    }
    private onDlgOk_AttributeType(event:any){
        this.logger.debug("AttributeType DLG RESULT : OK " + event);
        switch(this.dlg_att_type){
            case DLG_Type.DLG_ADD:
                this.addAttributeType();
            break;
            case DLG_Type.DLG_REMOVE:
                this.removeAttributeType();
            break;
            case DLG_Type.DLG_UPDATE:
                this.updateAttributeType();
            break;
        }
    }
    private openAttributeDlg(type:DLG_Type):void{
        if(this.company_select_item.id>0){
            this.dlg_att_show = true;
        }else{
            alert(this.translate.instant('MESSAGE_Select_Company_First'));
        }
        this.dlg_att_type = type;
        this.dlg_att_disable = true;
        //this.company_edit_item = Object.assign({},this.company_select_item);
        switch(type){
            case DLG_Type.DLG_ADD:
                this.dlg_att_header  = "ATTRIBUTE - ADD "
                this.dlg_att_disable = false;
								this.dlg_com_id_hide = true;
								this.attribute_edit_item.code = '';
								this.attribute_edit_item.name = '';
								this.attribute_edit_item.dsc = '';

            break;
            case DLG_Type.DLG_REMOVE:
                this.dlg_att_header  = "ATTRIBUTE - REMOVE "
								this.dlg_com_id_hide = false;
            break;
            case DLG_Type.DLG_UPDATE:
                this.dlg_att_header  = "ATTRIBUTE - UPDATE "
                this.dlg_att_disable = false;
								this.dlg_com_id_hide = false;
            break;
        }
    }
    private onAttributeSelected(event:any):void{
        this.attribute_select_item = event.data;
        this.attribute_edit_item = Object.assign({},this.attribute_select_item);
        this.logger.debug("Attribute : " , this.attribute_select_item);
        this.logger.debug("Attribute : " , this.attribute_edit_item);

        this.loadAttributeValueNode();
    }

    ///////////////////////////////////////////////////////////////////////////////////////
    private loadAttributeValueNode():void{
        var url = this.url_atttype + "/tree";
        var p_params = new URLSearchParams();
				this.logger.debug(this.attribute_select_item.id);
        p_params.set("attId" ,String(this.attribute_select_item.id));
        this.service.get(url,null,p_params).subscribe(
            value => {
                this.logger.debug("value : ", value);
                this.attrvalue_root_node = [value];
                //this.attrvalue_root_node = value;
								this.logger.debug("attrvalue_root_node :", this.attrvalue_root_node);
            },error=>{this.logger.error("-- error : " + error);}
        )
    }
    private addAttributeValue():void{
        //console.log("여기가 속성값 추가해주는 부분");

        console.log("attrvalue_edit_item",this.attrvalue_edit_item);
        var p_params = new URLSearchParams();
        p_params.set("attId" ,String(this.attribute_select_item.id));
        p_params.set("parentId" ,String(this.attrvalue_selected_node.id));
        p_params.set("code",this.attrvalue_edit_item.code);
        p_params.set("name",this.attrvalue_edit_item.name);
        p_params.set("dsc" ,this.attrvalue_edit_item.dsc);
        let code = this.attrvalue_edit_item.code;

        //if(glob.kyungnamIsTrue) {
            if(this.attrvalue_edit_item.code == '' || this.attrvalue_edit_item.code == null){
                alert("code를 입력해 주세요.");
                return;
            }
            if(code.match(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g)){
                alert("한글을 입력하지마세요.");
                return;
            
            }
        //}
        
        if(this.attrvalue_edit_item.name == '' || this.attrvalue_edit_item.name == null){
            alert(this.translate.instant('MESSAGE_Enter_Attribute_value'));
         } else {
                   this.service.post(this.url_atvalue,null,p_params).subscribe(
                    value => {
                        this.logger.debug("-- value : " , value);
                        if(value.id == -1){
                            alert(this.translate.instant('MESSAGE_AttributeCode_Name_Exist'));
                        }else{
                            this.loadAttributeValueNode();
                        }
                    },error=>{this.logger.error("-- error : " + error);}
                );
            }
    }


    private removeAttributeValue():void{
        var p_params = new URLSearchParams();
				this.logger.debug(this.attrvalue_selected_node);
        p_params.set("attId" ,String(this.attrvalue_selected_node.id));
        this.service.del(this.url_atvalue,String(this.attrvalue_selected_node.id),p_params).subscribe(
            value => {}
						,error=>{this.logger.error("-- error : " + error);}
						,()=>{
							{
								this.logger.debug("after node :" , this.attrvalue_selected_node	);
								if(this.attrvalue_selected_node.type == "TYPE") {
									this.loadAttributeList(this.company_select_item.id);
								} else {
									this.loadAttributeValueNode();
								}
							}
						}
        )
    }
    
	//20200515 박두호 애트리뷰트 수정버튼
    private updateAttributeValue():void{

        let code = this.attrvalue_edit_item.code;

            if(code == '' || code == null){
                alert("code를 입력해 주세요.");
                return;
            }
            if(code.match(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g)){
                alert("한글을 입력하지마세요.");
                return;
            
            }
 
        if(this.attrvalue_selected_node.name == '' || this.attrvalue_selected_node.name == null){
            alert(this.translate.instant('MESSAGE_Enter_Attribute_value'));
         } else {
             
                let updateItem = {id : this.attrvalue_selected_node.id, idx: this.attrvalue_edit_item.idx, code: code, dsc : this.attrvalue_edit_item.dsc , type: this.attrvalue_selected_node.type, depth: this.attrvalue_selected_node.depth, name: this.attrvalue_selected_node.name};
        
                   this.service.put(this.url_atvalue,null,updateItem).subscribe(
                    value => {
                        this.logger.debug("-- value : " , value);
                        if(value.id == -1){
                            alert(this.translate.instant('MESSAGE_AttributeCode_Name_Exist'));
                        }else{
                            this.loadAttributeValueNode();
                        }
                    },error=>{this.logger.error("-- error : " + error);}
                );
            }
    }

    private onDlgOk_AttributeValue(event):void{
        this.logger.debug("ATTRIBUTE VALUE DLG RESULT : OK " + this.dlg_atv_type);
        switch(this.dlg_atv_type){
             case DLG_Type.DLG_ADD:
                this.addAttributeValue();
            break;
            case DLG_Type.DLG_REMOVE:
                this.removeAttributeValue();
            break;
            //20200515 박두호 애트리뷰트 수정버튼
            case DLG_Type.DLG_UPDATE:
                this.updateAttributeValue();
            break;
        }
    }
    private openAttributeValueDlg(type:DLG_Type):void{
        this.dlg_atv_show = true;
        this.dlg_atv_type = type;
        this.dlg_atv_disable = true;
        switch(type){
            case DLG_Type.DLG_ADD:
                this.dlg_atv_header  = "ATTRIBUTE VALUE - ADD "
                this.dlg_atv_disable = false;
                this.attrvalue_edit_item = Object.assign({});
            break;
            case DLG_Type.DLG_REMOVE:
                this.dlg_atv_header  = "ATTRIBUTE VALUE - REMOVE "
                //20200515 박두호 애트리뷰트 수정버튼
                this.dlg_atv_disable = true;
            break;
            case DLG_Type.DLG_UPDATE:
                this.dlg_atv_header  = "ATTRIBUTE VALUE - UPDATE "
                this.dlg_atv_disable = false;
            break;
            
        }
    }
    private onAttributeNodeSelect(data:any){
        this.logger.debug("selected tree node : ", data);
        this.attrvalue_selected_node = data.node;
        if(data.node != null){
            this.attrvalue_edit_item = data.node;
        }
    }

		onChange(event) {
			this.logger.debug(this.company_edit_item.companyType);
			this.logger.debug(event);
		}

    randomCodeCreate() {
        //랜덤코드
        let code = "R";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 8; i++) {
            code += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        var d = new Date();
        var dateText= "";
        var today = d.toISOString().substring(0, 10);
        code += today.replace('-','').replace('-','');
        dateText = d.toTimeString().split(' ')[0].replace(':','').replace(':','');
        code += dateText;

        this.attrvalue_edit_item.code = code;

    }

    notKorean(event){
        console.log(event);
        if (!(event.keyCode ==37 || event.keyCode ==46 ||event.keyCode ==37 || event.keyCode ==39)) {
            event.returnValue = false;
            if(this.attrvalue_edit_item.code.match(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g)){
                let temp = this.attrvalue_edit_item.code.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
                this.attrvalue_edit_item.code = "";
                this.attrvalue_edit_item.code = temp.trim().toString();
                console.log(temp);
            }
            //event.target.value = event.target.value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
            //this.attrvalue_edit_item.code = this.attrvalue_edit_item.code.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
        }
    }

    onDragStart(event, node) {
        
    }



}

@NgModule({
    imports:[FormsModule,PanelModule, CommonModule,HttpModule, DropdownModule, DataTableModule,SplitButtonModule,MenuModule,BrowserModule,ExDialogExModule,TreeModule,ContextMenuModule, TranslatePipeMoudle, ReactiveFormsModule],
    declarations:[CompanyManagerPageComponent],
    exports:[CompanyManagerPageComponent],
    providers:[GuideService,ErrorService]
})
export class CompanyManagerPageModule{

}



// WEBPACK FOOTER //
// ./src/app/page/system/company_mgr.page.ts